@if (layout.layoutConf.useBreadcrumb && layout.layoutConf.breadcrumb === 'simple') {
  <div class="breadcrumb-bar">
    <ul class="breadcrumb">
      @for (part of routeParts; track part) {
        <li><a routerLink="/{{part.url}}">{{part.breadcrumb | translate}}</a></li>
      }
    </ul>
  </div>
}

@if (layout.layoutConf.useBreadcrumb && layout.layoutConf.breadcrumb === 'title') {
  <div class="breadcrumb-title">
    <h1 class="bc-title">{{routeParts[routeParts.length -1]['breadcrumb'] | translate}}</h1>
    @if (routeParts.length > 1) {
      <ul class="breadcrumb">
        @for (part of routeParts; track part) {
          <li><a routerLink="/{{part.url}}" class="text-muted">{{part.breadcrumb | translate}}</a></li>
        }
      </ul>
    }
  </div>
}